export default __webpack_public_path__ + "e4e1c89184bd51ab53363a13b7090451.svg";